import { render } from "./two-col-sidebar.vue?vue&type=template&id=6e0efd95"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__